import StateManager from "./state-manager.service";

export class LegacyAccountNavigationService {
  static $inject = ["AEStateManager"];
  constructor(private readonly AEStateManager: StateManager) {}

  isAccountActive() {
    return this.AEStateManager.current.isAccount();
  }
}
